/**
 * Copy shared by the message-form sections. `confirmationReminderText` was
 * declared identically in both DataCaptureSection and MessageTextSection, so a
 * wording change had to be made twice to stay correct.
 */

export const CONFIRMATION_REMINDER_TEXT =
  '<br/>Please confirm your appointment by replying Y or Yes to this message. To make changes please call.';

export const DATE_CAPTURE_FORMAT_NOTE =
  'NOTE: Response must be in the format of YYYY/MM/DD or YYYY-MM-DD.';
